import i18next from 'i18next';

import {InvoiceLine} from 'types/invoices';
import {CodeResponseType} from 'types/validation';

export const invoiceValidationWithTransportCodes = (
    response: CodeResponseType,
    data: InvoiceLine[],
) => {
    const {errors, isValid, info} = response;
    const mappedErrors: string[] = errors.map((e) => e.message);

    if (!isValid) mappedErrors.push(i18next.t('components.scan.errors.invalid_status'));

    if (
        data.find((d) => {
            const codeAtFirstLevel = d.code === info.identityCode;
            if (codeAtFirstLevel) return true;
            const codeInCombinedCodes = d.combinedCodes?.includes(info.identityCode);
            return codeInCombinedCodes ?? false;
        })
    )
        mappedErrors.push(i18next.t('components.scan.errors.double'));

    return mappedErrors;
};

export const goodsDeclarationValidation = (resposne: CodeResponseType, data: any[]) => {
    const {errors, isValid, info} = resposne;
    const mappedErrors: string[] = errors.map((e) => e.message);

    if (!isValid) mappedErrors.push(i18next.t('components.scan.errors.invalid_status'));

    if (data.find((d) => d.markingCode === info.identityCode))
        mappedErrors.push(i18next.t('components.scan.errors.double'));

    return mappedErrors;
};
